<template>
  <el-row type="flex" >
    <el-col v-for="(item,index) in list" :key="index" class="um-step" :class="{on:active>index}">
      <div class="child">
        <div class="xh">{{ index+1 }}</div>
        <div class="info">
          <div class="title">
            <span>{{ item.title }}</span>
            <span class="line" />
          </div>
          <div class="description">{{ item.description }}</div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'UmSteps',
  props: {
    // 每个 step 的间距，不填写将自适应间距。支持百分比。
    space: {
      type: [Number, String],
      default: null
    },
    active: {
      type: Number,
      default: 0
    },
    list: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped lang="scss">
  .um-step{
    margin-left: 0px;
    .child:after{
      content:"";
      display: block;
      clear: both;
    }
    &:last-child{
      width: auto;
      white-space: nowrap;
      .line{
        display: none;
      }
    }
    &.on{
      .xh{
        background: linear-gradient(180deg, #56A7F8 0%, #2B6EEF 100%);
        box-shadow: 0px 2px 4px 0px #B8D7FC;
      }
      .info{
        .title{
          color:#333;
          .line{
            border-bottom:1px dashed #357BF1;
            &:before{border:1px solid #357BF1;}
            &:after{border:1px solid #357BF1;}
          }
        }
      }
    }
    .xh{
      float: left;
      width: 30px;
      height: 30px;
      margin-right: -30px;
      line-height: 30px;
      text-align: center;
      border-radius:50%;
      color:#fff;
      background: #DADADA;
    }
    .info{
      margin-left: 50px;
      padding-top: 4px;
      .title{
        display: flex;
        align-items: center;
        color:#AAAAAA;
        .line{
          position: relative;
          flex:1;
          margin:0 20px;
          border-bottom:1px dashed #DADADA;
          &:before{
            content:"";
            display: block;
            position: absolute;
            left:0;
            top:50%;
            width: 8px;
            height: 8px;
            border:1px solid #DADADA;
            background: #fff;
            border-radius:50%;
            margin-top: -4px;
          }
          &:after{
            content:"";
            display: block;
            position: absolute;
            right:0;
            top:50%;
            width: 8px;
            height: 8px;
            border:1px solid #DADADA;
            background: #fff;
            border-radius:50%;
            margin-top: -4px;
          }
        }
      }
      .description{
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
      }
    }
  }

</style>
